import React, { lazy } from 'react';
import { motion } from 'framer-motion';
interface ImageCarouselProps {
  images: string[];
  /** Seconds for one full loop. Lower = faster. */
  speed?: number;
}
export function ImageCarousel({
  images,
  speed = 30
}: ImageCarouselProps) {
  // Duplicate the set so the marquee loops seamlessly.
  const loop = [...images, ...images];
  return <div className="relative w-full overflow-hidden" aria-label="Galeria di imagennan" data-id="element-53">
      {/* Edge fades */}
      <div className="absolute left-0 top-0 bottom-0 w-12 md:w-24 bg-gradient-to-r from-brand-bg to-transparent z-10 pointer-events-none" data-id="element-54" />
      <div className="absolute right-0 top-0 bottom-0 w-12 md:w-24 bg-gradient-to-l from-brand-bg to-transparent z-10 pointer-events-none" data-id="element-55" />

      <motion.div className="flex gap-5 md:gap-6 w-max" animate={{
      x: ['0%', '-50%']
    }} transition={{
      duration: speed,
      repeat: Infinity,
      ease: 'linear'
    }} data-id="element-56">
        {loop.map((src, i) => <div key={i} className="h-64 md:h-80 shrink-0 rounded-2xl overflow-hidden border border-brand-gold/25 shadow-[0_0_30px_rgba(0,0,0,0.5)]" data-id="element-57">
            <img src={src} alt="" aria-hidden="true" className="h-full w-auto object-cover" loading="lazy" data-id="element-58" />
          </div>)}
      </motion.div>
    </div>;
}